// Get the widget script URL
export const getWidgetBaseUrl = () => {
  const scriptElement = document.getElementById('appmanager-widget-js');
  if (scriptElement) {
    const scriptSrc = scriptElement.getAttribute('src');
    return scriptSrc?.replace('widget.bundle.js', '');
  }
  return '';
};